import sprite from './../../assets/sprite.svg';
const SpriteIcon = ({ id, size = 20, fill='#e9f2ff', ...props }: any) => {
    return (
        <svg height={size} width={size} fill={fill} {...props}>
            <use href={`${sprite}#${id}`} />
        </svg>
    );
};

export default SpriteIcon;